/**
 * A closing popover gives the focus back to its trigger, as Radix does, only when the focus has nowhere else to be:
 * the popover took it along when it went (`<body>`). When the person has already put it somewhere else — the next
 * control they pressed while the popover was fading out — it stays there.
 *
 * Radix decides this from its own record of a press outside, and that record is deferred to the press's `click`
 * (`deferPointerDownOutside`). When the fade ends inside that click, React lets the popover go in the same commit,
 * the record is never completed, and Radix focused the trigger after the click: on Safari a ⋯ menu opened that way
 * lost its focus to a rail picker's trigger and shut at once (S6 gate run 7, `history.spec.ts`). Radix moves the
 * focus on a timer after the content has left the page, so the focus is never inside it by then.
 */
export function keepMovedFocus<E extends Event>(own?: (event: E) => void) {
  return (event: E) => {
    own?.(event);
    const active = document.activeElement;
    if (active !== null && active !== document.body) event.preventDefault();
  };
}
